import { render, staticRenderFns } from "./TabTransactions.vue?vue&type=template&id=2d5e40e0&"
import script from "./TabTransactions.vue?vue&type=script&lang=js&"
export * from "./TabTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports